
import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';
import * as E from '@/enums';

import AxAPI from '@/api';

@Component
export default class AxACUBlock extends Mixins(AxPage) {
  state: State = new State();

  get isAccubank() {
    return this.state.deviceType === E.EDeviceType.ACCU_BANK_5400 ||
      this.state.deviceType === E.EDeviceType.ACCU_BANK_5800
      ? true
      : false;
  }

  get headers() {
    if (this.isAccubank) {
      return [
        { text: '확장 보드 ID', value: 'portIdUpper', align: 'start' },
        { text: '포트 ID', value: 'readerID', align: 'start' },
        { text: '사용', value: 'portUse', align: 'start' }
      ];
    } else {
      return [
        { text: '확장 보드 ID', value: 'extID', align: 'start' },
        { text: '포트 ID', value: 'portID', align: 'start' },
        { text: '보드 종류', value: 'boardType', align: 'start' }
      ];
    }
  }
}
